import { render } from "./Field.vue?vue&type=template&id=8575f2ba"
import script from "./Field.vue?vue&type=script&lang=js"
export * from "./Field.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/wpcm/fields/Field.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8575f2ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8575f2ba', __exports__)) {
    api.reload('8575f2ba', __exports__)
  }
  
  module.hot.accept("./Field.vue?vue&type=template&id=8575f2ba", () => {
    api.rerender('8575f2ba', render)
  })

}


export default __exports__